/* eslint-disable no-unused-vars */
import api from '@utils/api'

const formatJsonId = (array) => array.map(item => ({id: item}))

export const getAdministrators = () => async (_dispatch, _getState) => {
  const response = await api.getAdministrators()
  return response
}

export const deleteAdmin = ({ correo, justification }) => async (_dispatch, _getState) => {
  const data = {
    reason: justification,
  };
  const response = await api.deleteAdmin(correo, data);
  return response;
};

export const createAdmin = () => async (_dispatch, getState) => {
  const { user, isAllCountriesVisible, optionCountriesVisible, profileSelect } = getState().admins
  const { countriesCurrentCatalog } = getState().catalogs
  let validateCountries = optionCountriesVisible
  if (isAllCountriesVisible) {
    validateCountries = countriesCurrentCatalog.map(item => item.id)
  }
  const data = {
    correo: user.correo,
    admin_paises: isAllCountriesVisible ? "ALL" : "SOME",
    perfiles: formatJsonId(profileSelect),
    paises: isAllCountriesVisible ? [] : formatJsonId(validateCountries),
  }

  const response = await api.assignAdmin(data);
  return response;
};

export const editAdmin = (justification) => async (_dispatch, getState) => {
  const { user, isAllCountriesVisible, optionCountriesVisible, profileSelect } = getState().admins
  const { countriesCurrentCatalog } = getState().catalogs
  let validateCountries = optionCountriesVisible
  if (isAllCountriesVisible) {
    validateCountries = countriesCurrentCatalog.map(item => item.id)
  }
  const data = {
    correo: user.correo,
    admin_paises: isAllCountriesVisible ? "ALL" : "SOME",
    perfiles: formatJsonId(profileSelect),
    paises: isAllCountriesVisible ? [] : formatJsonId(validateCountries),
  }

  const response = await api.editAdmin(data);
  return response;
};


